import React from 'react';

import PropTypes from 'prop-types';

import DashboardPagination from 'components/common/DashboardPagination';
import { UAVOS_ICONS, UAVO_TYPE_FALLBACK } from 'consts/mapConfig';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';

import { formStyles } from 'consts/styles/Form';

import DetailsCard from './DetailsCard/DetailsCard';

const DisplayUavosDetails = props => {
  const { follow, zoomToUavo } = props;

  const selectedUavos = useSelector(state => state.selectedDashboardUavos);
  const mappingUavos = useSelector(state => state.mappingUavos);
  const strings = useSelector(state => state.language).uavoDetails;

  const [uavoToDisplay, setUavoToDisplay] = React.useState(null);
  const [paginationNumber, setPaginationNumber] = React.useState(1);

  const formClasses = formStyles();

  React.useEffect(() => {
    if (selectedUavos.length) {
      setUavoToDisplay(selectedUavos[0]);
    }
  }, [selectedUavos]);

  React.useEffect(() => {
    if (!uavoToDisplay) return;
    setUavoToDisplay(selectedUavos[paginationNumber - 1]);
  }, [paginationNumber]);

  const getUavoSrc = () => {
    const { data } = uavoToDisplay.getProperties();
    return mappingUavos[data.type] || mappingUavos[UAVO_TYPE_FALLBACK[data.type]] || UAVOS_ICONS.ufo;
  };

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item xs={12}>
          {uavoToDisplay ? (
            <DetailsCard
              uavo={uavoToDisplay}
              follow={follow}
              zoomToUavo={zoomToUavo}
              src={getUavoSrc()}
              isSelectButton={selectedUavos.length}
            />
          ) : (
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            >
              {strings.noItems_}
            </Typography>
          )}
        </Grid>
        {selectedUavos.length > 1 && (
          <DashboardPagination
            paginationCounter={selectedUavos.length}
            paginationNumber={paginationNumber}
            setPaginationNumber={setPaginationNumber}
          />
        )}
      </Grid>
    </>
  );
};

DisplayUavosDetails.propTypes = {
  follow: PropTypes.func.isRequired,
  zoomToUavo: PropTypes.func.isRequired,
};

export default DisplayUavosDetails;
